import { fabric } from 'fabric';
import { renderCustomCroppingControl } from './render-custom-cropping-control';

export const setCustomCroppingControls = ({ _fabric }: any, isNewToolbarEnabled = false) => {
  // Override drawControls function to draw custom controls for cropping rect
  _fabric.Object.prototype.drawControls = function (ctx, styleOverride) {
    styleOverride = styleOverride || {};
    ctx.save();
    const retinaScaling = this.canvas ? this.canvas.getRetinaScaling() : 1;
    let matrix, p;
    ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
    ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;
    if (!this.transparentCorners) {
      ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
    }
    this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray);
    this.setCoords();
    if (this.group) {
      matrix = this.group.calcTransformMatrix();
    }

    this.forEachControl(function (control, key, fabricObject) {
      p = fabricObject.oCoords[`${key}`];
      if (control.getVisibility(fabricObject, key)) {
        if (matrix) {
          p = fabric.util.transformPoint(p, matrix);
        }
        // render custom controls for cropping-rect in WAM, otherwise call fabricjs' original render function
        if (fabricObject.name === 'cropping-rect') {
          renderCustomCroppingControl(key, ctx, p.x, p.y, fabricObject, isNewToolbarEnabled);
        } else {
          control.render(ctx, p.x, p.y, styleOverride, fabricObject);
        }
      }
    });
    ctx.restore();
    return this;
  };
};
